<template>
  <v-card>
    <v-card-title>
      <v-row no-gutters>
        <v-col class="title" cols="3">
          {{ title }}
        </v-col>
        <v-col class="text--secondary" cols="4">
          <v-fade-transition leave-absolute>
            <v-row no-gutters>
              <v-col cols="12">Items amount: {{ rows.length }}</v-col>
            </v-row>
          </v-fade-transition>
        </v-col>
        <v-col class="d-flex justify-end" cols="5">
          <v-btn outlined color="primary" width="100" @click="handleCollapse">
            {{ isCollapsed ? 'Show' : 'Hide' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text v-if="!isCollapsed">
      <v-data-table
        disable-pagination
        hide-default-footer
        :headers="columns"
        :items="rows"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isCollapsed: false
    };
  },
  methods: {
    handleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
};
</script>
